export default "__VITE_ASSET__CTOdc4k$__"